<script lang="ts" setup>
// @ts-nocheck
import '../scss/Slider.scss';
import { getTypeMoney } from '../../../../helpers/getTypeMoneyByCountry';
import { reactive } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

const props = defineProps({
  subDomainInitial: {
    type: String,
    required: true,
  },
  dolarPrice: {
    type: Number,
    default: null,
  },
  UFvalue: {
    type: Number,
    default: null,
  },
  currency: {
    type: Object,
    default: {
      id: null,
      simbol: null
    },
  },
});

function createSliderConfig(
  value: number,
  min: number,
  max: number,
  marks: Record<number, any>,
  interval: number,
) {
  return {
    value,
    options: {
      dotSize: 20,
      width: 'auto',
      height: 4,
      contained: false,
      direction: 'ltr',
      min,
      max,
      interval: interval,
      disabled: false,
      clickable: false,
      duration: 0.5,
      adsorb: false,
      lazy: false,
      tooltip: 'always',
      tooltipPlacement: 'top',
      useKeyboard: false,
      enableCross: true,
      fixed: false,
      order: true,
      marks,
      process: true,
    },
  };
}


// Mascara slider chile

const chValue = Math.round((1000 * props.dolarPrice) / props.UFvalue);
// const chMin = Math.round((1000 * props.dolarPrice) / props.UFvalue);
// const chMax = Math.round((200000 * props.dolarPrice) / props.UFvalue);
const chMin = 1;
const chMax = 5000;
// const chValue = 500
// const chMin = 1200;
// const chMax = 20000;

const marksCH = {
  [chMin]: {
    label: 'UF ' + chMin.toLocaleString(),
    labelStyle: {
      color: '#000',
      fontSize: '1.2rem',
      marginTop: '20px',
    },
  },
  [chMax]: {
    label: 'UF ' + chMax.toLocaleString(),
    labelStyle: {
      color: '#000',
      fontSize: '1.2rem',
      marginTop: '20px',
    },
  },
};

const usdValue = 500;
const usdMin = 1200;
const usdMax = 500000;

const marksUSD = {
  [usdMin]: {
    label: 'USD ' + usdMin.toLocaleString(),
    labelStyle: {
      color: '#000',
      fontSize: '1.2rem',
      marginTop: '20px',
    },
  },
  [usdMax]: {
    label: 'USD ' + usdMax.toLocaleString(),
    labelStyle: {
      color: '#000',
      fontSize: '1.2rem',
      marginTop: '20px',
    },
  },
};

const getSliderConfig = () => {
  // if(props.currency.simbol == 'UF') {
    return createSliderConfig(1, chMin, chMax, marksCH, 1);
  // } else {
  //   return createSliderConfig(usdValue, usdMin, usdMax, marksUSD, 1);
  // }
};



const sliderData = reactive(getSliderConfig());

</script>


<template>
  <div class="policy-slider policy-slider--chile">
    <vue-slider
      @dragging="(val: number) => $emit('value', val)"
      v-model="sliderData.value"
      v-bind="sliderData.options"
      :tooltip-formatter="
        (val: number) => (getTypeMoney(props.subDomainInitial)) + ' ' + val.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      "
    />
  </div>
</template>
